export * as externalDatabase from '@wix/auto_sdk_data_external-database';